import styled from "styled-components";
import { Space } from "./Space";

const FullWidthSpace = styled(Space)`
  width: 100%;
`;

export { FullWidthSpace };
